export const GoogleIcon = () => (
  <svg
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.708 12.1942C19.708 11.5879 19.6536 11.0049 19.5525 10.4453H11.5V13.7526H16.1015C15.9032 14.8214 15.3009 15.7269 14.3953 16.3332V18.4784H17.1585C18.7753 16.9899 19.708 14.798 19.708 12.1942Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 20.5505C13.8085 20.5505 15.7439 19.7849 17.1585 18.4791L14.3953 16.3338C13.6297 16.8468 12.6503 17.1499 11.5 17.1499C9.27308 17.1499 7.38819 15.6459 6.71585 13.625H3.85938V15.8402C5.26624 18.6345 8.15769 20.5505 11.5 20.5505Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.71584 13.6244C6.54484 13.1114 6.44768 12.5634 6.44768 11.9999C6.44768 11.4364 6.54484 10.8884 6.71584 10.3754V8.16016H3.85936C3.28029 9.31441 2.94995 10.6202 2.94995 11.9999C2.94995 13.3795 3.28029 14.6854 3.85936 15.8396L6.71584 13.6244Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 6.85369C12.7553 6.85369 13.8823 7.28508 14.7684 8.13231L17.2207 5.68001C15.74 4.30035 13.8046 3.45312 11.5 3.45312C8.15769 3.45312 5.26624 5.3691 3.85938 8.1634L6.71585 10.3786C7.38819 8.35772 9.27308 6.85369 11.5 6.85369Z"
      fill="#EA4335"
    />
  </svg>
);
